import { JoinViewType } from '@/core/presenter/viewModel/viewTypes';
import { useCallback, useState } from 'react';
import JoinGuideView from './components/JoinGuideView';
import JoinUserInfoView from './components/JoinUserInfoView';
import JoinPwdSettingView from './components/JoinPwdSettingView';
import JoinPinSettingView from './components/JoinPinSettingView';

const Join = (): JSX.Element => {
  const [viewType, setViewType] = useState<JoinViewType>(JoinViewType.JOIN_GUIDE);

  /** sms 인증 화면으로 이동하는 함수 */
  const onClickMoveToSmsBtn = useCallback(() => {
    setViewType(JoinViewType.JOIN_CHECK_USER_INFO);
  }, []);

  const onClickMoveToPwdSettingBtn = useCallback(() => {
    setViewType(JoinViewType.JOIN_PWD_SETTING);
  }, []);

  const onClickMoveToPinSettingBtn = useCallback(() => {
    setViewType(JoinViewType.JOIN_PIN_SETTING);
  }, []);

  return (
    <>
      {viewType === JoinViewType.JOIN_GUIDE && <JoinGuideView onClick={onClickMoveToSmsBtn} />}
      {viewType === JoinViewType.JOIN_CHECK_USER_INFO && <JoinUserInfoView onClick={onClickMoveToPwdSettingBtn} />}
      {viewType === JoinViewType.JOIN_PWD_SETTING && <JoinPwdSettingView onClick={onClickMoveToPinSettingBtn} />}
      {viewType === JoinViewType.JOIN_PIN_SETTING && <JoinPinSettingView />}
    </>
  );
};

export default Join;
